import { memo, useState, useEffect, useRef } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import useWindowWidth from '../../WindowWidth';

import resets from '../../../_resets.module.css';
import classes from './Language.module.scss';
import { PolygonIconUnder } from './PolygonIconUnder';

interface Props {
  className?: string;
  classes?: {
    rectangle142?: string;
    group68?: string;
    root?: string;
  };
}

export const Language: FC<Props> = memo(function Language(props = {}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
 

  const changeLanguageAndNavigate = (lang) => {
    i18n.changeLanguage(lang);
    // 現在の言語部分を新しい言語に置き換える
    const newPath = pathname.replace(/^\/(ja|en|zh)/, `/${lang}`);
    navigate(newPath);
    setIsOpen(false);
  };
  
  
  const [isOpen, setIsOpen] = useState(false);  // メニューの開閉状態を管理するステート
  const menuRef = useRef<HTMLDivElement | null>(null);
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= 1023;
navigate
  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    if (isOpen && isMobile) {
      document.body.classList.add('no-scroll');
      document.addEventListener('click', handleDocumentClick);
    } else {
      document.body.classList.remove('no-scroll');
      document.addEventListener('click', handleDocumentClick);
    }

    return () => {
      document.body.classList.remove('no-scroll');
      document.addEventListener('click', handleDocumentClick);
      };
  }, [isOpen, windowWidth]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div ref={menuRef} className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.root}`}>
      <div className={`${classes.language} ${isOpen ? classes.selected : ''}`} onClick={toggleMenu}>
      {isMobile ? "LANG" : "Language"}
        <div className={classes.polygon}>
          <PolygonIconUnder className={classes.icon} />
        </div>
      </div>
      {isOpen && (
          <div className={classes.dropdownMenu}>
            <div className={classes.menuItem}  onClick={() => changeLanguageAndNavigate('ja')}>日本語</div>
            <div className={classes.menuItem} onClick={() => changeLanguageAndNavigate('en')}>English</div>
            {/* <div className={classes.menuItem} onClick={() => changeLanguageAndNavigate('zh')}>中文</div> */}
          </div>
        )}
    </div>
  );
});
